import * as React from "react"

const Veteran = (): React.ReactElement => (
    <svg
        viewBox="0 0 200 250"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M198.4 71.5V71c-.2-1.2-1.4-2.1-1.4-2.1L103.2 2.7c-.7-.4-1-.6-1.6-.6-1.3 0-2.3 1-2.3 2.3v67.1h-.6v29.6h99.8l-.1-29.6z"
            fill="#004876"
        />
        <path
            d="M172.9 159.2c-31.4 23-33.2 24.3-33.2 24.3l-40.5 3.2v-29.4l73.7 1.9z"
            fill="#FFF"
        />
        <path
            d="M99.3 125.4V33.5L1.6 102.7l-.1.1c-1 .7-1.5 1.8-1.5 3v67.4c0 1.2.6 2.3 1.5 3l.1.1 93.5 66.3c1.7 1.2 4.1 0 4.1-2.1v-28.9l40.5-28-40.5.7v-25h73.7l25.4-16.9.2-16.8H99.3z"
            fill="#BB2432"
        />
        <path d="M99.3 101.1h99.3v24.3H99.3z"
            fill="#FFF"
        />
    </svg>
)

export default Veteran
